import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import React, { useState } from "react";
import { AppBar, IconButton, Button as MaterialButton, Toolbar, Typography } from "@mui/material";
import { useNotify, TextInput, useRefresh, SimpleForm, CheckboxGroupInput, useCreate, useGetList } from "react-admin";
import { Close } from "@mui/icons-material";

export const CreatePermissions = (props) => {
  const [checkboxFields, setCheckBoxFields] = useState([]);
  const [open, setOpen] = useState(false);
  const [create] = useCreate();
  const { data, error } = useGetList("internal_permissions", { meta: "getResources" });
  const notify = useNotify();
  const refresh = useRefresh();

  const resources = async () => {
    var resources = [];
    if (data) {
      for (var i = 0; i < data.length; i++) {
        resources.push(data[i].value);
      }
      setCheckBoxFields(resources);
    }
    if (error) {
      notify(`Error retrieving IA resources: \n ${JSON.stringify(error)}`, { type: "error" });
    }
  };

  const createGroup = async (data) => {
    await create(
      "internal_permissions",
      { meta: "createGroup", data: { group: data.group } },
      {
        onSuccess: () => {
          notify(`${data.group} has been successfully created`);
        },
        onError: () => {
          notify(`Failed to create group: ${data.group}. Check Sentry for details.`, { type: "error" });
        },
      }
    );
  };

  const createNewPermissions = async (data) => {
    for (var i = 0; i < checkboxFields.length; i++) {
      let requested_perms = data[checkboxFields[i]];
      let resource = checkboxFields[i];
      let new_read = false;
      let new_write = false;
      let new_active = false;
      if (requested_perms != undefined) {
        new_write = data[checkboxFields[i]].includes("write");
        new_read = data[checkboxFields[i]].includes("read") || new_write;
        new_active = data[checkboxFields[i]].includes("is_active");
      }
      create(
        "internal_permissions",
        { data: { group: data.group, resource: resource, read: new_read, write: new_write, is_active: new_active } },
        {
          onSuccess: () => {
            notify(`Permissions created for ${data.group}`);
          },
          onError: () => {
            notify(`Failed to add permissions. Check Sentry for details.`, { type: "error" });
          },
        }
      );
    }
  };

  const handleOpen = () => {
    setOpen(true);
    resources();
  };

  const handleSubmit = async (data) => {
    await createGroup(data);
    await createNewPermissions(data);
    setOpen(false);
    refresh();
  };

  const emailCheck = (email) => {
    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return emailRegex.test(email) ? undefined : "Invalid Email Format";
  };

  const permissions_options = [
    { id: "is_active", name: "Active" },
    { id: "read", name: "Read" },
    { id: "write", name: "Write" },
  ];
  return (
    <>
      <MaterialButton
        variant="contained"
        color="primary"
        onClick={() => {
          handleOpen();
        }}
        sx={{ marginBottom: "10px" }}
      >
        Create New Group
      </MaterialButton>
      <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby="create-permissions" fullScreen>
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={() => setOpen(false)} aria-label="close">
              <Close />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Create New Group
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <SimpleForm onSubmit={handleSubmit} {...props}>
            <TextInput
              source="group"
              label="Google Group Email"
              sx={{ height: 40 }}
              required={true}
              validate={emailCheck}
            />
            {checkboxFields.map((field, index) => (
              <CheckboxGroupInput
                key={index}
                source={`${field}`}
                choices={permissions_options}
                label={field}
                sx={{ height: "40px" }}
              />
            ))}
          </SimpleForm>
        </DialogContent>
      </Dialog>
    </>
  );
};
